import { getCourseScheduleDates, getPublicCourseSchedule } from "@/lib/course-schedule";
import CustomerScheduleList from "@/components/course/customer-schedule-list";
import { scheduleAssessmentLines } from "@/utils/course-schedule-popover";
import { courseScheduleBookingError } from "@/utils/scheduling-booking";

export default function CourseBookingSchedule({ event }: { event: any }) {
  if (!event) return null;
  const error = courseScheduleBookingError(event);
  const result = getPublicCourseSchedule(event);
  if (error || !result.ok) return <p role="alert" className="mt-3 rounded-md border border-amber-300 bg-amber-50 p-3 text-sm text-amber-900">{error || "Course schedule unavailable."}</p>;
  const assessments = scheduleAssessmentLines(event);
  return (
    <details className="mt-3 rounded-md border border-gray-200 bg-white text-gray-800">
      <summary className="cursor-pointer px-3 py-2 text-sm font-medium focus-visible:outline focus-visible:outline-2 focus-visible:outline-brand-600">View your course schedule</summary>
      <div className="px-3 pb-2 text-sm">
        <CustomerScheduleList dates={getCourseScheduleDates(event)} />
        {assessments.length ? <div><p className="font-medium">End point assessment</p>{assessments.map((line, index) => <p key={index}>{line}</p>)}</div> : null}
      </div>
    </details>
  );
}
